import {
  MIN_COLUMN_WIDTH,
  MAX_COLUMN_WIDTH,
  DEFAULT_LABEL_COLUMN_WIDTH,
  MIN_LABEL_COLUMN_WIDTH,
  DEFAULT_PADDING,
  DROPDOWN_PADDING_ADJUSTMENT,
  GROUP_HEADER_FONT,
  EXTERNAL_ICON_WIDTH,
} from "../constants"
import { calculateOptimalColumnWidth } from "./text-measurement"
import { get } from "lodash"

// Freshness dot (8px) plus its right margin (6px), reserved left of the label.
const INTRADAY_FRESHNESS_DOT_ALLOWANCE = 14

function calculateOptimalWidth(sortedContributorsArray, currentLevelData, dropdownTableTitle = false, showsFreshnessDot = false) {
  if (!sortedContributorsArray || sortedContributorsArray.length === 0) return MIN_COLUMN_WIDTH

  // Prepare items array including contributors and aggregation data
  const items = [...sortedContributorsArray]

  // Also include the aggregation/total row label if it exists
  if (currentLevelData && currentLevelData.label) {
    items.push(currentLevelData)
  }

  const basePadding = dropdownTableTitle ? DROPDOWN_PADDING_ADJUSTMENT : DEFAULT_PADDING + EXTERNAL_ICON_WIDTH
  const padding = basePadding + (showsFreshnessDot ? INTRADAY_FRESHNESS_DOT_ALLOWANCE : 0)

  // Use GROUP_HEADER_FONT because it's the largest of all fonts.
  return calculateOptimalColumnWidth(items, "label", GROUP_HEADER_FONT, {
    minWidth: MIN_COLUMN_WIDTH,
    maxWidth: MAX_COLUMN_WIDTH,
    defaultWidth: DEFAULT_LABEL_COLUMN_WIDTH,
    padding,
  })
}

export const createLabelColumn = ({
  idLabel,
  dropdownTableTitle,
  sortMetricId,
  isAbsoluteSort,
  sortArrowDirection,
  metricMetadata,
  onSortChange,
  data,
  sortedContributorsArray,
  handleClickContributor,
  includeDrilldownArrows,
  isTopLevel,
  handleSetTableLevel,
  parentLevelOptions,
  currentGroupId,
  LabelCellComponent,
  CustomHeaderComponent,
  savedDataGridState,
  onDrilldownRowClick,
  intradayPricePrefix,
}) => {
  const optimalWidth = calculateOptimalWidth(sortedContributorsArray, data, dropdownTableTitle, Boolean(intradayPricePrefix))

  // Priority: saved state > calculated optimal > default
  const savedWidth = get(savedDataGridState, "columns.dimensions.label.width")
  let columnWidth = DEFAULT_LABEL_COLUMN_WIDTH
  if (savedWidth && savedWidth > 0) {
    columnWidth = savedWidth
  } else if (optimalWidth && optimalWidth > columnWidth) {
    columnWidth = optimalWidth
  }

  return {
    field: "label",
    headerName: idLabel || "ID",
    type: "string",
    width: columnWidth,
    minWidth: MIN_LABEL_COLUMN_WIDTH,
    align: "left",
    headerAlign: "left",
    sortable: false, // We handle sorting manually
    renderCell: (params) => (
      <LabelCellComponent
        params={params}
        handleClickContributor={handleClickContributor}
        includeDrilldownArrows={includeDrilldownArrows}
        isTopLevel={isTopLevel}
        handleSetTableLevel={handleSetTableLevel}
        dropdownTableTitle={dropdownTableTitle}
        parentLevelOptions={parentLevelOptions}
        currentGroupId={currentGroupId}
        onDrilldownRowClick={onDrilldownRowClick}
        intradayPricePrefix={intradayPricePrefix}
      />
    ),
    renderHeader: (params) => (
      <CustomHeaderComponent
        field="label"
        colDef={params.colDef}
        sortMetricId={sortMetricId}
        isAbsoluteSort={isAbsoluteSort}
        sortArrowDirection={sortArrowDirection}
        metricMetadata={metricMetadata}
        onSortChange={onSortChange}
        data={data}
      />
    ),
    pinnable: false,
  }
}
